import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IPatientCaseRejectionReasonDriver, defaultValue } from 'app/shared/model/patient-case-rr-driver.model';

export const ACTION_TYPES = {
  FETCH_PATIENT_CASE_RR_DRIVER_LIST: 'patientCaseRrDriver/FETCH_PATIENT_CASE_RR_DRIVER_LIST',
  FETCH_PATIENT_CASE_RR_DRIVER: 'patientCaseRrDriver/FETCH_PATIENT_CASE_RR_DRIVER',
  FETCH_PATIENT_CASE_RR_DRIVER_BY_PATIENT_CASE: 'patientCaseRrDriver/FETCH_PATIENT_CASE_RR_DRIVER_BY_PATIENT_CASE',
  FETCH_PATIENT_CASE_RR_DRIVER_BY_DRIVER: 'patientCaseRrDriver/FETCH_PATIENT_CASE_RR_DRIVER_BY_DRIVER',
  FETCH_PATIENT_CASE_RR_DRIVER_BY_RR_DRIVER: 'patientCaseRrDriver/FETCH_PATIENT_CASE_RR_DRIVER_BY_RR_DRIVER',
  CREATE_PATIENT_CASE_RR_DRIVER: 'patientCaseRrDriver/CREATE_PATIENT_CASE_RR_DRIVER',
  UPDATE_PATIENT_CASE_RR_DRIVER: 'patientCaseRrDriver/UPDATE_PATIENT_CASE_RR_DRIVER',
  DELETE_PATIENT_CASE_RR_DRIVER: 'patientCaseRrDriver/DELETE_PATIENT_CASE_RR_DRIVER',
  RESET: 'patientCaseRrDriver/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IPatientCaseRejectionReasonDriver>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type PatientCaseRRDriverState = Readonly<typeof initialState>;

// Reducer

export default (state: PatientCaseRRDriverState = initialState, action): PatientCaseRRDriverState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_PATIENT_CASE_RR_DRIVER_LIST):
    case REQUEST(ACTION_TYPES.FETCH_PATIENT_CASE_RR_DRIVER):
    case REQUEST(ACTION_TYPES.FETCH_PATIENT_CASE_RR_DRIVER_BY_PATIENT_CASE):
    case REQUEST(ACTION_TYPES.FETCH_PATIENT_CASE_RR_DRIVER_BY_DRIVER):
    case REQUEST(ACTION_TYPES.FETCH_PATIENT_CASE_RR_DRIVER_BY_RR_DRIVER):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_PATIENT_CASE_RR_DRIVER):
    case REQUEST(ACTION_TYPES.UPDATE_PATIENT_CASE_RR_DRIVER):
    case REQUEST(ACTION_TYPES.DELETE_PATIENT_CASE_RR_DRIVER):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_PATIENT_CASE_RR_DRIVER_LIST):
    case FAILURE(ACTION_TYPES.FETCH_PATIENT_CASE_RR_DRIVER):
    case FAILURE(ACTION_TYPES.FETCH_PATIENT_CASE_RR_DRIVER_BY_PATIENT_CASE):
    case FAILURE(ACTION_TYPES.FETCH_PATIENT_CASE_RR_DRIVER_BY_DRIVER):
    case FAILURE(ACTION_TYPES.FETCH_PATIENT_CASE_RR_DRIVER_BY_RR_DRIVER):
    case FAILURE(ACTION_TYPES.CREATE_PATIENT_CASE_RR_DRIVER):
    case FAILURE(ACTION_TYPES.UPDATE_PATIENT_CASE_RR_DRIVER):
    case FAILURE(ACTION_TYPES.DELETE_PATIENT_CASE_RR_DRIVER):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_PATIENT_CASE_RR_DRIVER_LIST):
    case SUCCESS(ACTION_TYPES.FETCH_PATIENT_CASE_RR_DRIVER_BY_PATIENT_CASE):
    case SUCCESS(ACTION_TYPES.FETCH_PATIENT_CASE_RR_DRIVER_BY_DRIVER):
    case SUCCESS(ACTION_TYPES.FETCH_PATIENT_CASE_RR_DRIVER_BY_RR_DRIVER):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_PATIENT_CASE_RR_DRIVER):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_PATIENT_CASE_RR_DRIVER):
    case SUCCESS(ACTION_TYPES.UPDATE_PATIENT_CASE_RR_DRIVER):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_PATIENT_CASE_RR_DRIVER):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/patient-case-rejection-reason-driver';

// Actions

export const getEntities: ICrudGetAllAction<IPatientCaseRejectionReasonDriver> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_PATIENT_CASE_RR_DRIVER_LIST,
  payload: axios.get<IPatientCaseRejectionReasonDriver>(`${apiUrl}?cacheBuster=${new Date().getTime()}`),
});

export const getEntity = (patientCaseId: string, driverId: string) => {
  const requestUrl = `${apiUrl}/${patientCaseId}/${driverId}`;
  return {
    type: ACTION_TYPES.FETCH_PATIENT_CASE_RR_DRIVER,
    payload: axios.get<IPatientCaseRejectionReasonDriver>(requestUrl),
  };
};

export const getEntitiesByPatientCase = (patientCaseId: string) => ({
  type: ACTION_TYPES.FETCH_PATIENT_CASE_RR_DRIVER_BY_PATIENT_CASE,
  payload: axios.get<IPatientCaseRejectionReasonDriver>(`${apiUrl}/by-patient-case/${patientCaseId}?cacheBuster=${new Date().getTime()}`),
});

export const getEntitiesByDriver = (driverId: string) => ({
  type: ACTION_TYPES.FETCH_PATIENT_CASE_RR_DRIVER_BY_DRIVER,
  payload: axios.get<IPatientCaseRejectionReasonDriver>(`${apiUrl}/by-driver/${driverId}?cacheBuster=${new Date().getTime()}`),
});

export const getEntitiesByRrDriver = (rrDriverId: string) => ({
  type: ACTION_TYPES.FETCH_PATIENT_CASE_RR_DRIVER_BY_RR_DRIVER,
  payload: axios.get<IPatientCaseRejectionReasonDriver>(`${apiUrl}/by-rejection-reason-driver/${rrDriverId}?cacheBuster=${new Date().getTime()}`),
});

export const createEntity: ICrudPutAction<IPatientCaseRejectionReasonDriver> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_PATIENT_CASE_RR_DRIVER,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const updateEntity: ICrudPutAction<IPatientCaseRejectionReasonDriver> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_PATIENT_CASE_RR_DRIVER,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity = (patientCaseId: string, driverId: string) => async dispatch => {
  const requestUrl = `${apiUrl}/${patientCaseId}/${driverId}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_PATIENT_CASE_RR_DRIVER,
    payload: axios.delete(requestUrl),
  });
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
